// extracted by mini-css-extract-plugin
export var explainable = "_gv-a";
export var printerCard = "_gv-1";
export var printerCardConfigured = "_gv-2";
export var printerCardError = "_gv-3";
export var printerCardsContainer = "_gv-0";
export var printerIcon = "_gv-8";
export var printerIconConfigured = "_gv-5";
export var printerIconContainer = "_gv-4";
export var printerIconError = "_gv-6";
export var printerIconUnconfigured = "_gv-7";
export var workstationsTableCard = "_gv-9";